import React from "react";
import classNames from "classnames";
import { Col, Page, Row, Typography } from "@payping/web-components";

import { buildUrl } from "@payping/utilities-shared/url";
import { useAppTranslation } from "@/utils/useAppTranslation";
import styles from "@/assets/scss/dashCustomer/groupCreate.module.scss";
import Uploader from "./Upload";
import { URLS } from "@payping/utilities-shared/consts";

const CreateBulk: React.FC = () => {
  const { t } = useAppTranslation();

  const warnings = t("customer.createBulk.warnings", { returnObjects: true }) as any;

  return (
    <Page>
      <Row justify={"center"} className={classNames(styles.container, "tw:w-full")}>
        <Col xs={24} sm={20} md={16} lg={14} xl={12}>
          <Row>
            <Col span={24} className={styles.groupCreateTip}>
              <Typography.Text>{t("customer.createBulk.createBulkTip")}</Typography.Text>
              <Typography.Link download href={buildUrl(URLS.STORAGE_URL, "PayPing_Customers_Template.xlsx").toString()}>
                {t("customer.createBulk.downloadSampleFile")}
              </Typography.Link>
            </Col>
            <Col span={24}>
              <Typography.Paragraph>
                <ul>
                  {warnings.map((warning: string, index: number) => (
                    <li key={`${index}`}>
                      <Typography.Text>{warning}</Typography.Text>
                    </li>
                  ))}
                </ul>
              </Typography.Paragraph>
            </Col>
            <Col span={24} className={styles.uploadContainer}>
              <Uploader />
            </Col>
          </Row>
        </Col>
      </Row>
    </Page>
  );
};

export default CreateBulk;
